// react-client/src/features/feedback/hooks/useFeedbackFilter.js
import { useState, useCallback } from 'react';
import { feedbackService } from '../services/feedbackService';
import { useSnackbar } from '../../../hooks/mui/useSnackBar';

export function useFeedbackFilter() {
  const [feedbackItems, setFeedbackItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { showError } = useSnackbar();

  const filterFeedback = useCallback(async (filters, options = {}) => {
    setLoading(true);
    setError(null);

    try {
      const response = await feedbackService.filterFeedback(filters, options);
      setFeedbackItems(response.data.feedback_items);
      setTotalCount(response.data.total_count);
      return { success: true, data: response.data };
    } catch (err) {
      const errorMessage = err.message || 'Failed to filter feedback';
      setError(errorMessage);
      showError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  }, [showError]);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  const clearResults = useCallback(() => {
    setFeedbackItems([]);
    setTotalCount(0);
  }, []);

  return {
    feedbackItems,
    totalCount,
    loading,
    error,
    filterFeedback,
    clearError,
    clearResults,
  };
}